import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzVc6 } from './pages'

type TIdToPageMapWoofzVc6 = Record<PageIdWoofzVc6, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_VC6: TIdToPageMapWoofzVc6 = {
  [PageIdWoofzVc6.SEX_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/DogSexQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/DogSexQuestionVC'),
  },
  [PageIdWoofzVc6.DOG_AGE_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/DogAgeQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/DogAgeQuestionVC'),
  },
  [PageIdWoofzVc6.SHELTER_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/ShelterQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/ShelterQuestionVC'),
  },
  [PageIdWoofzVc6.DOG_BREED_VC6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vc6/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vc6/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzVc6.BEHAVIOR_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/BehaviorQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/BehaviorQuestionVC'),
  },
  [PageIdWoofzVc6.HEALTH_ISSUES_VC6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vc6/pages/questions/HealthIsuesQuestionVC'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/HealthIsuesQuestionVC'),
  },
  [PageIdWoofzVc6.GOALS_QUESTION_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/GoalsQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/GoalsQuestionVC'),
  },
  [PageIdWoofzVc6.URGE_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/urge/UrgePageVC').then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vc6/pages/urge/UrgePageVC'),
  },
  [PageIdWoofzVc6.FEED_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/FeedQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/FeedQuestionVC'),
  },
  [PageIdWoofzVc6.WALK_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/WalkQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/WalkQuestionVC'),
  },
  [PageIdWoofzVc6.STRESS_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/StressQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/StressQuestionVC'),
  },
  [PageIdWoofzVc6.HOME_ALONG_VC6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vc6/pages/questions/HomeAlongQuestionVC'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/HomeAlongQuestionVC'),
  },
  [PageIdWoofzVc6.ACTIVITY_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/ActivityQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/ActivityQuestionVC'),
  },
  [PageIdWoofzVc6.DESCRIBE_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/questions/DescribeQuestionVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/questions/DescribeQuestionVC'),
  },
  [PageIdWoofzVc6.ALMOST_DONE_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/urge/AlmostDoneVC').then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vc6/pages/urge/AlmostDoneVC'),
  },
  [PageIdWoofzVc6.TRAINER_IS_READY_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/urge/TrainerIsReadyVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/urge/TrainerIsReadyVC'),
  },
  [PageIdWoofzVc6.DOG_SUMMARY_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/info/DogCardScreenVC').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_vc6/pages/info/DogCardScreenVC'),
  },
  [PageIdWoofzVc6.FEATURE_DESCRIPTION_VC6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vc6/pages/info/FeaturesDescriptionVCVariant2'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vc6/pages/info/FeaturesDescriptionVCVariant2'
      ),
  },
  [PageIdWoofzVc6.CYNOLOGISTS_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/info/CynologistsVCVariant2').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/info/CynologistsVCVariant2'),
  },
  [PageIdWoofzVc6.OUR_MISSION_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/urge/OurMissionVC').then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vc6/pages/urge/OurMissionVC'),
  },
  [PageIdWoofzVc6.LIMITED_OFFER_VC6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vc6/pages/last-chance-offer/LimitedOfferVC'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/last-chance-offer/LimitedOfferVC'),
  },
  [PageIdWoofzVc6.SUBSCRIPTIONS_TRIAL_PRICE_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/subscriptions/Subscriptions').then(
        (m) => ({
          default: m.TrialPriceSubscriptionsPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzVc6.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/subscriptions/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/subscriptions/CancelOffer'),
  },
  [PageIdWoofzVc6.CALENDLY_VC6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vc6/pages/final/CalendlyWidgetPageVariant3'
      ).then((m) => ({
        default: m.CalendlyWidgetPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vc6/pages/final/CalendlyWidgetPageVariant3'),
  },
  [PageIdWoofzVc6.ALL_SET_VC6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vc6/pages/final/AllSetVC').then((m) => ({
        default: m.AllSetVCPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vc6/pages/final/AllSetVC'),
  },
  [PageIdWoofzVc6.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
